import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';

import CtaCard from 'components/ui/CtaCard';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';

import { deepDiver } from 'helpers/utilities';
import { getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';

const DefaultSelectedOptions = (optionsSelected) =>
  getTranslatedString('landlordPortal.multiselectAdvanced.selected', {
    count: optionsSelected.length,
  });

const StyledSelect = styled(Select)`
  .ant-select-selection__rendered .ant-row {
    display: flex;
    align-items: center;
  }
`;

export const StyledLink = styled(CtaCard)`
  flex-grow: 1;
  padding: 8px;
  color: ${colors.PURE_BLUE};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  text-align: right;
`;

const StyledRightAlign = styled.div`
  text-align: right;
`;

/*
 * This component is temporarily only being used for ReduxForm to fix some issues
 * with MultiSelectExtended
 *
 */

const MultiSelect = ({
  name,
  reduxFormName,
  options,
  label,
  input,
  onChange,
  multiple,
  withResetSelectAllButtons,
  value,
  ...rest
}) => {
  const usingRedux = input ? true : false;

  const handleSelect = (values) => {
    // call onChange props if passed
    if (onChange) onChange(values);
    if (!usingRedux) return;

    const newValue = options.filter((option) => {
      if (Array.isArray(values)) {
        return values.includes(option.value);
      }
      return values === option.value;
    });

    input.onChange(newValue);
  };

  const handleSelectAll = () => {
    const allOptions = options.map((option) => option.value);

    // call onChange props if passed
    if (onChange) onChange(allOptions);

    if (usingRedux) {
      input.onChange(options);
      // input.onBlur(values);
    }
  };

  const handleDeselect = () => {
    // call onChange props if passed
    if (onChange) onChange([]);

    if (usingRedux) {
      input.onChange([]);
      // input.onBlur(values);
    }
  };

  const resetSelectAll = (menu, showSelectAll) => (
    <div>
      {showSelectAll && (
        <Row>
          <Col span={12}>
            <StyledLink
              onMouseDown={(e) => e.preventDefault()}
              onClick={handleSelectAll}
              type="button"
            >
              {getTranslatedString('landlordPortal.noticesMultiselect.selectAll')}
            </StyledLink>
          </Col>
          <Col span={12}>
            <StyledRightAlign>
              <StyledLink
                onMouseDown={(e) => e.preventDefault()}
                onClick={handleDeselect}
                type="button"
              >
                {getTranslatedString('landlordPortal.noticesMultiselect.deselect')}
              </StyledLink>
            </StyledRightAlign>
          </Col>
        </Row>
      )}
      {menu}
    </div>
  );

  let maxTagCount = usingRedux && input.value.length > 1 ? 0 : 1;
  let fieldValues = input && input.value.map((val) => val.value)

  if (value) {
    fieldValues = value
    if (value.length > 1) {
      maxTagCount = 0  
    }
  }

  const showSelectAll = withResetSelectAllButtons && multiple;

  return (
    <StyledSelect
      showSearch
      mode={multiple ? 'multiple' : null}
      onChange={handleSelect}
      placeholder={getTranslatedString('landlordPortal.propertyMultiselectAdvanced.searchSelect')}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={DefaultSelectedOptions}
      allowClear
      size="large"
      value={fieldValues}
      dropdownRender={(menu) => resetSelectAll(menu, showSelectAll)}
      filterOption={(input, option) => {
        const desiredPropertyOption = deepDiver(option, 'props.children');
        if (!desiredPropertyOption) return;

        return desiredPropertyOption.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      {...rest}
    >
      {options.map((option) => (
        <Select.Option key={`option-${option.value}`} {...option}>
          {option.label}
        </Select.Option>
      ))}
    </StyledSelect>
  );
};

export default MultiSelect;
